module.exports = __webpack_public_path__ + "img/product_70.7faee6f.webp";